import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { AppSettings } from 'src/app/modules/shared/model/appSettings.model';
import { HttpErrorHandler } from 'src/app/modules/shared/services/error-handler.service';
import { SettingService } from 'src/app/modules/shared/services/setting.service';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors'; 
import { addAppSettings, addAppSettingsSuccess, loadAppSettings, loadAppSettingsSuccess } from '../actions/app-settings.actions';



@Injectable({
  providedIn: 'root'
})
export class AppEffects {

  public getLicenseRequiredForRegistration$ = createEffect(()=>
    this.actions$.pipe(
      ofType(addAppSettings),
      withLatestFrom(
        this.store.select(selectAppSettings),
        (store)=> store
      ),
      switchMap((currentState)=> {
        if(currentState.licenseRequiredForRegistrationSet){
          return of(currentState);
        }
        return this.settingsService.isLicenseRequiredForRegistration()
          .pipe(map(res => {
            const newState = {
              ...currentState,
              licenseRequiredForRegistrationSet: true,
              licenseRequiredForRegistration: res
            };
            return newState;
          }
        ));
      }),
      map(state => addAppSettingsSuccess(state)),
      catchError(this.errorHandler.handleError)
  ));

  constructor(private actions$: Actions,private store: Store<AppState>, private settingsService: SettingService,
    private errorHandler: HttpErrorHandler) {}

}
